module.exports = __webpack_public_path__ + "static/frontUserNew/img/icon-type-user.4a4b9af9.png";